// src/pages/DeniedPage.js
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const DeniedPage = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        padding: 3,
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: "bold" }}
      >
        Access Denied
      </Typography>
      <Typography variant="body1">
        You do not have permission to access this app. This may be because:
      </Typography>
      <Typography variant="body2">
        - Your account has not been granted access yet
        <br />
        - You are not assigned to any children
        <br />- You tried to access a child that you do not have permission for
      </Typography>
      <Typography
        variant="body2"
        sx={{ mt: 1 }}
      >
        If you believe this is a mistake, please contact the person who invited
        you.
      </Typography>
      <Button
        onClick={handleBackToLogin}
        variant="text"
        sx={{ mt: 2 }}
      >
        Back to Login
      </Button>
    </Box>
  );
};

export default DeniedPage;
